import React from 'react';
import Icon from './Icon';


function IconChevronDown(props) {
  return (<>
    <Icon width="24" height="11" style={props?.style} className={props?.className}>
      <path fillRule="evenodd" clipRule="evenodd" d="M9.70711 2.79289C10.0976 3.18342 10.0976 3.81658 9.70711 4.20711L5.70711 8.20711C5.31658 8.59763 4.68342 8.59763 4.29289 8.20711L0.292893 4.20711C-0.0976315 3.81658 -0.0976315 3.18342 0.292893 2.79289C0.683417 2.40237 1.31658 2.40237 1.70711 2.79289L5 6.08579L8.29289 2.79289C8.68342 2.40237 9.31658 2.40237 9.70711 2.79289Z" />
    </Icon>
  </>);
};

export default IconChevronDown;
